// src/App.js
import React from "react";
import "./App.css";
import HomePage from "./HomePage";
import SignIn from "./SignIn";
import PurchaseCredits from "./PurchaseCredits";
import Support from "./Support";
import Settings from "./Settings";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import DashboardLayout from "./DashboardLayout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import DevDashboard from "./DevDashboard";
import PlaytestPage from "./PlaytestPage";
import InviteTester from "./InviteTester";
import TesterDashboard from "./TesterDashboard";
import SessionDetail from "./SessionDetail"; // ⬅️ NEW
import NewGame from "./NewGame"; // ⬅️ NEW

import TermsOfService from "./TermsOfService";
import PrivacyPolicy from "./PrivacyPolicy";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <SignIn />
              </PublicRoute>
            }
          />

          <Route path="/termsofservice" element={<TermsOfService />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DevDashboard />} />
            <Route path="games/new" element={<NewGame />} />   {/* ⬅️ NEW */}

            <Route path="tester" element={<TesterDashboard />} />
            <Route path="testers/invite" element={<InviteTester />} />
            <Route path="purchase" element={<PurchaseCredits />} />
            <Route path="support" element={<Support />} />
            <Route path="settings" element={<Settings />} />

            {/* NEW: per-session view */}
            <Route path="sessions/:sessionId" element={<SessionDetail />} />
          </Route>

          <Route path="/play" element={<PlaytestPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
